import { toast } from 'react-toastify';
import { Form } from '@ui';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CCSchedulerSettingsInputsFormType } from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/types';
import { CCSchedulerSettingsInputsForm } from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/components';
import {
  ccSchedulerSettingInputsFormSchema,
  getDefaultCCSettingInputsValues,
} from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/config';
import { useCCScheduleSettingsInputsQuery, useCCSetScheduleSettingsInputsMutation } from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';

export const CCSchedulerSettingsInputsTab = () => {
  const { data: inputsData } = useCCScheduleSettingsInputsQuery();
  const { mutateAsync, isPending } = useCCSetScheduleSettingsInputsMutation();

  const handleSubmit = async (data: CCSchedulerSettingsInputsFormType) => {
    try {
      await mutateAsync(data);
      toast.success(`Scheduler Settings updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!inputsData) return null;

  return (
    <Form<CCSchedulerSettingsInputsFormType>
      defaultValues={getDefaultCCSettingInputsValues(inputsData)}
      schema={ccSchedulerSettingInputsFormSchema}
      onSubmit={handleSubmit}
    >
      <CCSchedulerSettingsInputsForm />
      <SchedulerSettingsSubmitRow backPath="/schedule/cc" isLoading={isPending} />
    </Form>
  );
};
